

















import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import notificationService from '@/services/notificationService';
import TaskTemplatesRepository from '@/modules/tasks/templates/TaskTemplatesRepository';
import EmployeesRepository from '@/modules/employees/employeesRepository';
import { selectableEmployees } from '@/modules/employees/employeeSelection';
import Datagrid from '@/components/default/Datagrid.vue';
import { DxNavBar } from 'devextreme-vue';

@Component({
  components: {
    Datagrid,
    DxNavBar,
  },
})
export default class TaskTemplatesTable extends Vue {
  employees: any[] = [];
  employeesLoaded: boolean = false;
  loading: boolean = false;
  items: ITaskTemplateDto[] = [];

  created() {
    this.loadData();
    this.loadEmployees();
  }

  async loadEmployees() {
    try {
      this.employees = (await EmployeesRepository.get()).data;
    } catch {
      notificationService.showErrorMessage('Mislukt om de werknemers te laden!');
    } finally {
      this.employeesLoaded = true;
    }
  }

  async loadData() {
    try {
      this.loading = true;
      this.items = (await TaskTemplatesRepository.getAll()).data;
    } catch {
      notificationService.showErrorMessage('Mislukt om de templates te laden!');
    } finally {
      this.loading = false;
    }
  }

  refresh() {
    try {
      ((this.$refs.rentalGrid as Datagrid).$refs.taskTemplatesGrid as any).instance.refresh();
    } catch {
      notificationService.showErrorMessage('Mislukt om de grid te refreshen!');
    }
  }

  editRow(e: any) {
    if (e && e.row && !e.row.isEditing && e.column && e.column.type !== 'buttons') {
      this.$router.push({ path: `/tasks/templates/${e.data.id}` });
    }
  }

  async deleteRow(e: any) {
    const self = this;
    e.cancel = new Promise(async (resolve, reject) => {
      try {
        await TaskTemplatesRepository.delete(e.data.id);
        notificationService.saved();
        resolve(false);
      } catch (err) {
        notificationService.showAxiosError(err);
        resolve(true);
      }
    });
  }

  addTemplate() {
    this.$router.push({ path: `/tasks/templates/create` });
  }

  get columns() {
    const self = this;
    return [
      {
        dataField: 'name',
        caption: 'Naam',
      },
      {
        dataField: 'team',
        caption: 'Team',
        lookup: {
          items: EmployeesRepository.getTeams(),
          valueExpr: 'value',
          displayExpr: 'text',
        },
      },
      {
        dataField: 'assignedUserId',
        caption: 'Gebruiker',
        lookup: {
          // OS-214: hide disabled employees from the filter dropdown, but keep any employee
          // already assigned as a template's default so existing rows keep showing their name.
          items: selectableEmployees(this.employees, {
            currentValue: this.items.map((item: any) => item.assignedUserId).filter(Boolean),
            idField: 'adUserId',
          }),
          valueExpr: 'adUserId',
          displayExpr: 'displayName',
        },
      },
      {
        type: 'buttons',
        buttons: ['edit', 'delete'],
      },
    ];
  }

  get toolbarOptions() {
    const self = this;

    return [
      {
        location: 'before',
        widget: 'dxButton',
        options: {
          icon: 'fas fa-plus',
          text: 'Toevoegen',
          stylingMode: 'outlined',
          type: 'success',
          onClick: this.addTemplate,
        },
      },
    ];
  }
}
